<template>
  <div class="sourceWrapper">
    <div class="tabs is-toggl">
      <ul class="">
        <li :class="isActiveClass(index)" v-for="(item,index) in categoryList" v-on:click="onTabClick(item, index)">
            <a><span>{{ item.name }} </span></a>
        </li>
      </ul>
    </div>
    <div class="list-wrap">
      <div  class="clearfix">
        <div class="fleft">
          <div v-if="sourceType === 10 || sourceType === 11 || sourceType === 12" class="like-button fleft">
            <p class="buttonStyle">
              <router-link class="button is-success width-2" :to="{ name: 'setSource', query: {type: this.sourceType,name:inputText} }">新增{{inputText}}号</router-link>
            </p>
          </div>
          <input class="input width-2 fleft margin-left" type="text" placeholder="搜索账号" v-model="accountName">
          <button class="button is-primary fleft" @click="doSarch()" >搜索</button>
          <button class="button is-info" @click="clear" style="margin-left: 20px;">清空</button>
        </div>
        <el-pagination
          v-if="count > 0"
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>头像</th>
                <th>名称</th>
                <th>accountKey</th>
                <th>最近更新时间</th>
                <th>创建时间</th>
                <th>内容数</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in list">
                <td>{{item.accountId}}</td>
                <td>
                  <image-component v-if="item.avatar && item.avatar.image" :image="item.avatar" :width="150" :compress="1.2"></image-component>
                </td>
                <td>
                  <p v-if="sourceType == 10 || sourceType == 11"><a :href="item.accountPage" target="_blank">{{item.accountName}}</a></p>
                  <p v-else>{{item.accountName}}</p>
                </td>
                <td>{{ item.accountKey }}</td>
                <td>
                  <div class="time">{{item.updateTime}}</div>
                </td>
                <td>{{item.createTime}}</td>
                <td>{{item.feedCount}}</td>
                <td style="text-align: center;">
                  <el-button type="primary" :disabled="item.updating > 0" @click='manualUpdate(index, item.accountId, item.type)'>手动更新</el-button>
                  <button v-if="sourceType === 10 || sourceType === 11 || sourceType === 12" class="button is-primary" @click="goEdit(item)">编辑</button>
                  <button v-else :class="{ 'is-primary': item.status ===0, 'is-danger': item.status === 1 }" class="button" @click="dealSubscribe(item, index)">{{ item.status === 0 ? '订阅' : '取消订阅' }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script type="text/babel">
  import {formatDate} from 'UTILS/date'

  export default {
    data(){
      return {
        inputText: '',
        categoryList: [],
        activeIndex: 0,
        categoryName: '',
        sourceType: '',
        list:[],
        count:0,
        accountName: '',
        search:{
          page:1,
          pageSize:20
        },
      }
    },
    mounted(){
       if (this.$route.query.page) {
        this.search.page = this.$route.query.page*1;
        this.accountName = this.$route.query.accountName;
        this.activeIndex = this.$route.query.activeIndex*1;
      }
      this.getInitialSourceTypeList();
    },
    methods:{
      manualUpdate(index, accountId, type) {
        HttpRequest.get("/admin.php?method=fashion.manualUpdateSource", {accountId: accountId, type: type}).then((response) => {
          this.$message("更新中.....")
          this.list[index].updating = 1
        })
      },
      /**
       * 接收子组件pagination分页点击事件
       * @param  {[type]} value [description]
       * @return {[type]}       [description]
       */
      handleCurrentChange(val){
        if(this.search.page !== val){
          this.search.page = val;
          this.getSourceList(this.search)
        }
      },
      /**
       * 获取初始化数据列表；
       */
      getSourceList(_params){
        let params = {
          type: this.sourceType,
          accountName: this.accountName,
          page: _params.page,
          pageSize: _params.pageSize,
        }
        HttpRequest.get('/admin.php?method=fashion.getSourceList', params).then(response => {
          if (response) {
            _.each(response.data.list,(item,index)=>{
              item.updateTime = formatDate(item.updateTime,'yyyy-MM-dd hh:mm:ss');
            })
            this.list = _.toArray(response.data.list);
            this.count = response.data.count;
          }
        })
      },
      /**
       * 获取初始分类列表；
       */
      getInitialSourceTypeList() {
        HttpRequest.get('/admin.php?method=fashion.getSourceTypeList').then(response => {
          this.categoryList = _.toArray(response.data);
          if ( this.$route.query.type ) {
            this.sourceType = this.$route.query.type * 1;
            this.getActiveTabIndex();
            this.inputText = response.data[this.activeIndex].name;
          } else {
            this.sourceType = response.data[0].type;
            this.inputText = response.data[0].name;
          }
          this.getSourceList(this.search);
        })

      },
      getActiveTabIndex() {
        if ( this.$route.query.type ) {
          this.categoryList.forEach((item, index) => {
            if ( item.type === this.$route.query.type*1 ) {
              this.activeIndex = index;
            }
          })
        }
      },
      onTabClick(item, index) {
        this.accountName = '';
        this.search.page = 1;
        this.inputText = item.name;
        this.activeIndex = index;
        this.sourceType = item.type;
        this.getSourceList(this.search)
      },
      doSarch() {
        this.search.page = 1;
        this.getSourceList(this.search);
      },
      dealSubscribe(_obj, index) {
        let _status = _obj.status === 1 ? 0 : 1;
        let params = {
          accountId: _obj.accountId,
          status: _status,
        }
        let _noteMessage = _status === 1 && '订阅成功！' || '取消订阅成功！';
        if( _status === 0 ){
          if ( confirm('确认取消订阅？') ) {
            this.sendSubscripeRequests(params, _noteMessage, index);
          }
        }
        if ( _status !== 0 ) {
          this.sendSubscripeRequests(params, _noteMessage, index);
        }
      },
      sendSubscripeRequests(params, _noteMessage, index) {
        HttpRequest.post("/admin.php?method=fashion.setSourceStatus",params).then((response)=>{
          if(response.data.success){
            this.$message(_noteMessage);
            this.list[index].status = params.status;
          }
        });
      },
      goEdit(item) {
        this.$router.push({
          name: 'editSource',
          query: {
            type: this.sourceType,
            accountId: item.accountId,
            name: this.inputText,
            page: this.search.page,
            accountName: this.accountName,
            activeIndex: this.activeIndex,
          }
        })
      },
      clear() {
        this.$router.push({
          name: 'subscripeSource',
        })
        this.search.page = 1;
        this.accountName = '';
        this.activeIndex = 0;
      },
      isActiveClass(index){
        if(this.activeIndex == index){
          return "is-active"
        }else{
          return ""
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .like-tabs {
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;
  }
  .active {
    border-bottom: 1px solid #337ab7;
  }
</style>

